(function () {
  'use strict';

  var ENDPOINT = '/api/submit-form';

  function submitForm(form) {
    var wrapper = form.closest('.w-form');
    var successEl = wrapper ? wrapper.querySelector('.w-form-done') : null;
    var errorEl = wrapper ? wrapper.querySelector('.w-form-fail') : null;

    // Show submitting state
    var submitBtn = form.querySelector('[type="submit"]');
    var originalValue = '';
    if (submitBtn) {
      originalValue = submitBtn.value || submitBtn.textContent;
      var waitText = submitBtn.getAttribute('data-wait') || 'Please wait...';
      if (submitBtn.tagName === 'INPUT') {
        submitBtn.value = waitText;
      } else {
        submitBtn.textContent = waitText;
      }
      submitBtn.disabled = true;
    }

    var payload = {};
    var formData = new FormData(form);
    formData.forEach(function (value, key) { payload[key] = value; });
    payload._formName = form.getAttribute('data-name') || form.getAttribute('name') || form.id || '';
    payload._page = window.location.pathname;

    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) { return res.json().catch(function () { return { success: false }; }); })
      .then(function (data) {
        if (data && (data.success === true || data.success === 'true')) {
          form.style.display = 'none';
          if (successEl) {
            successEl.style.display = 'block';
          }
        } else {
          if (errorEl) {
            errorEl.style.display = 'block';
          }
          if (submitBtn) {
            submitBtn.disabled = false;
            if (submitBtn.tagName === 'INPUT') {
              submitBtn.value = originalValue;
            } else {
              submitBtn.textContent = originalValue;
            }
          }
        }
      })
      .catch(function () {
        if (errorEl) {
          errorEl.style.display = 'block';
        }
        if (submitBtn) {
          submitBtn.disabled = false;
          if (submitBtn.tagName === 'INPUT') {
            submitBtn.value = originalValue;
          } else {
            submitBtn.textContent = originalValue;
          }
        }
      });
  }

  // Intercept ALL form submit events in capture phase (runs before webflow.js listeners)
  document.addEventListener('submit', function (e) {
    var form = e.target;

    // Only handle Webflow forms (identified by data-wf-element-id attribute)
    if (!form.getAttribute('data-wf-element-id')) return;

    // Skip the calculator forms — they compute locally and never submit to a server
    if (form.classList.contains('calculator_contact_form')) return;

    // Skip the Webflow password-protection form on 401.html
    if (form.classList.contains('w-password-page')) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    submitForm(form);
  }, true); // capture phase = fires before webflow.js bubble-phase listeners

  // Budget field show/hide: only visible when "New Website" service is picked
  var WEBSITE_VALUES = ['website', 'Nouveau site web'];

  function toggleBudget(serviceSelect) {
    var form = serviceSelect.closest('form');
    if (!form) return;
    var budget = form.querySelector('[data-budget-field]');
    if (!budget) return;
    var show = WEBSITE_VALUES.indexOf(serviceSelect.value) !== -1;
    budget.style.display = show ? '' : 'none';
    if (!show) {
      var sel = budget.querySelector('select');
      if (sel) sel.selectedIndex = 0;
    }
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (!t.matches('select[name="contact-service"], select[name="contact-service-2"]')) return;
    toggleBudget(t);
  });

  function initBudgetFields() {
    var selects = document.querySelectorAll('select[name="contact-service"], select[name="contact-service-2"]');
    Array.prototype.forEach.call(selects, toggleBudget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBudgetFields);
  } else {
    initBudgetFields();
  }

})();

